import * as angular from 'angular';
import { config } from '../../angular/utils/config';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('FcfsBookingStageThreeCtrl', FcfsBookingStageThreeCtrl);

    function FcfsBookingStageThreeCtrl(
        $log,
        $scope,
        $route,
        authService,
        fcfsBookingService,
        Fcfs,
        DATES,
        TradeProposals,
        log
    ) {
        var vm = this;
        var runtime = fcfsBookingService.getStageTwo().interval;

        vm.submit = submit;
        vm.appBaseUrl = config.appBaseUrl;
        vm.isLoggedIn = authService.isLoggedIn();
        vm.generalError =
            'An error occurred while processing your request. Please check whether you received a booking confirmation email and contact the support if necessary.';
        vm.DATES = DATES;

        vm.ui = {
            generalError: false,
            submitting: false
        };
        fcfsBookingService.resetAllStagesAfter(3);
        vm.data = fcfsBookingService.getStageThree();
        vm.networkPoint = fcfsBookingService.getStageOne().selectedNetworkPoint;
        vm.capacityUnit =
            fcfsBookingService.getStageTwo().capacity.originalUnit;
        vm.checkResponse = fcfsBookingService.getStageTwo().checkResponse;
        vm.tsos = {
            tso0: fcfsBookingService.getStageOne().tso0,
            tso1: fcfsBookingService.getStageOne().tso1
        };
        vm.service = fcfsBookingService;

        vm.restart = restart;
        init();

        $scope.$watch(
            function () {
                return fcfsBookingService.selectedAlternative;
            },
            function () {
                getFcfsConfig();
            }
        );

        function init() {
            if (authService.isLoggedIn()) {
                vm.ui.loadingConfig = true;
                getFcfsConfig();
            }

            vm.matchingProposals = {
                paginator: {
                    itemsPerPage: 5,
                    currentPage: 1
                }
            };
            $scope.$watch(
                function () {
                    return vm.matchingProposals.paginator.currentPage;
                },
                function () {
                    fetchProposals(true);
                }
            );

            fetchProposals(false);
        }

        function getFcfsConfig() {
            var capacityCategories0 = null;
            var capacityCategories1 = null;
            if (
                fcfsBookingService.selectedAlternative &&
                fcfsBookingService.selectedAlternative.parts
            ) {
                var allCategories0 = {};
                var allCategories1 = {};
                angular.forEach(
                    fcfsBookingService.selectedAlternative.parts,
                    function (part) {
                        allCategories0[part.contract.capacityCategory0] = true;
                        if (part.contract.networkPoint.bundled) {
                            allCategories1[part.contract.capacityCategory1] =
                                true;
                        }
                    }
                );
                capacityCategories0 = Object.keys(allCategories0);
                capacityCategories1 = Object.keys(allCategories1);
            } else {
                capacityCategories0 =
                    fcfsBookingService.getStageTwo().capacityCategory0;
                capacityCategories1 =
                    fcfsBookingService.getStageTwo().capacityCategory1;
            }
            Fcfs.getFcfsConfig(
                {
                    networkPointId: vm.networkPoint.id,
                    runtimeStart:
                        fcfsBookingService.getStageTwo().interval.start,
                    runtimeEnd: fcfsBookingService.getStageTwo().interval.end,
                    capacityCategory0: capacityCategories0,
                    capacityCategory1: capacityCategories1
                },
                function (res) {
                    vm.config = res;
                    vm.ui.loadingConfig = false;
                },
                function () {
                    vm.ui.loadingConfig = false;
                }
            );
        }

        function fetchProposals(fromPaging) {
            if (!fromPaging) {
                vm.ui.loadingMatchingProposals = true;
            }
            TradeProposals.get(
                {
                    intervalMode: 'INCLUDED',
                    networkPoint: vm.networkPoint.id,
                    runtimeFrom: runtime.start,
                    runtimeTo: runtime.end,
                    pageSize: vm.matchingProposals.paginator.itemsPerPage,
                    start:
                        (vm.matchingProposals.paginator.currentPage - 1) *
                        vm.matchingProposals.paginator.itemsPerPage
                },
                function (res) {
                    vm.matchingProposals.page = res;
                    vm.ui.loadingMatchingProposals = false;
                },
                function () {
                    vm.ui.loadingMatchingProposals = false;
                }
            );
        }

        function submit(form: ng.IFormController) {
            if (!form.$valid) {
                $scope.wizard.goToTop();
                return false;
            }

            vm.ui.submitting = true;

            fcfsBookingService.setStageThree(vm.data);
            var promise = $scope.wizard.finished();
            promise.catch(function (err) {
                vm.ui.generalError = true;

                const errorMessage =
                    err && err.data && err.data.message
                        ? err.data.message
                        : 'An unknown error occurred. Please, check back later.';
                vm.generalError = errorMessage;

                fcfsBookingService.bookingError = vm.generalError;
                $scope.wizard.goToErrorPage();
            });
            promise.finally(function () {
                vm.ui.submitting = false;
            });
        }

        function restart() {
            fcfsBookingService.reset();
            $scope.$broadcast(fcfsBookingService.BROADCAST.WIZARD_RESTART);
            $route.updateParams({ stage: null });
        }
    }
})();
